import { SettingsItemProps } from "./types";
import * as Styled from "./styles";

const SettingsItem: React.FC<SettingsItemProps> = ({
  label,
  icon,
  description,
  ...rest
}): React.ReactElement => (
  <Styled.SettingsItem {...rest}>
    <Styled.SettingsItemIcon as={icon} />
    <Styled.SettingsItemLabel>{label || " "}</Styled.SettingsItemLabel>
    <Styled.SettingsItemDescription>
      {description || " "}
    </Styled.SettingsItemDescription>
  </Styled.SettingsItem>
);

export default SettingsItem;
